import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addCustomerSchedulePackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addCustomerSchedulePackage = createAsyncThunk('addCustomerSchedulePackage', async (payload) => {
  return await addCustomerSchedulePackageApi(payload);
});

const addCustomerSchedulePackageSlice = createSlice({
  name: 'addCustomerSchedulePackage', // Unique Name
  initialState,
  reducers: {
    addCustomerSchedulePackageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomerSchedulePackage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addCustomerSchedulePackage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addCustomerSchedulePackage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addCustomerSchedulePackageReset } = addCustomerSchedulePackageSlice.actions;

export default addCustomerSchedulePackageSlice.reducer;
